import React from 'react';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastIcon,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from './Toast';
import { useToast } from './useToast';

/**
 * Toaster component that renders all active toasts.
 * 
 * Add this component once at the root of your application.
 * 
 * @example
 * // In your app root
 * function App() {
 *   return (
 *     <>
 *       <YourAppContent />
 *       <Toaster />
 *     </>
 *   );
 * }
 * 
 * // To show a toast from anywhere
 * import { useToast } from '@/components/ui/Toast';
 * 
 * function MyComponent() {
 *   const { toast } = useToast();
 *   
 *   const handleClick = () => {
 *     toast({
 *       title: 'Success!',
 *       description: 'Your changes have been saved.',
 *       variant: 'success',
 *     });
 *   };
 * }
 */
export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map((toast) => (
        <Toast key={toast.id} variant={toast.variant}>
          <div className="flex items-start gap-3">
            {toast.variant && toast.variant !== 'default' && (
              <ToastIcon variant={toast.variant} />
            )}
            <div className="grid gap-1">
              {toast.title && <ToastTitle>{toast.title}</ToastTitle>}
              {toast.description && (
                <ToastDescription>{toast.description}</ToastDescription>
              )}
            </div>
          </div>
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </ToastProvider>
  );
}
